"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 監査結果表示コンポーネント（データ部）
 */
const ResultCells = props => {
  const {
    item,
    resultActions,
    shitekiActions,
    chiefHyokaActions
  } = props;
  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 3,
      sm: 6,
      md: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, item.kansakekkaCreStsText), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, item.dispKansakekkaCreDt && item.dispKansakekkaCreDt.split('\r\n').map((line, index) => /*#__PURE__*/_react.default.createElement("span", {
    key: index
  }, line, /*#__PURE__*/_react.default.createElement("br", null))))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 3,
      sm: 6,
      md: 6
    }
  }, item.dispBtnKansaansSts === true && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, resultActions)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 5
    }
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 5,
      sm: 5,
      md: 5
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, item.kaizenplanStsText), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, item.dispKaizenplanDt && item.dispKaizenplanDt.split('\r\n').map((line, index) => /*#__PURE__*/_react.default.createElement("span", {
    key: index
  }, line, /*#__PURE__*/_react.default.createElement("br", null))))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 4,
      sm: 4,
      md: 4
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, item.kaizenprogressStsText), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, item.dispKaizenprogressDt && item.dispKaizenprogressDt.split('\r\n').map((line, index) => /*#__PURE__*/_react.default.createElement("span", {
    key: index
  }, line, /*#__PURE__*/_react.default.createElement("br", null))))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 3,
      sm: 3,
      md: 3
    }
  }, item.dispBtnShitekiJikoKaizen === true && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, shitekiActions)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 4
    }
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 5,
      sm: 5,
      md: 5
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, item.hikansaChiefHyokaStsText), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, item.dispHikansabumonChiefHyokaDt && item.dispHikansabumonChiefHyokaDt.split('\r\n').map((line, index) => /*#__PURE__*/_react.default.createElement("span", {
    key: index
  }, line, /*#__PURE__*/_react.default.createElement("br", null))))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 7,
      sm: 7,
      md: 7
    }
  }, item.dispBtnikansabumonChiefHyoka === true && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, chiefHyokaActions)))));
};
var _default = exports.default = ResultCells;